"use strict";
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import Account from "../api/account";
import "../formatters/general";
import TypeAhead from "./ui/type_ahead";
import Auth from "../util/auth";
var CarrierTypeAhead = React.createClass({
  search: function(name) {
    var component = this;
    return Promise.resolve(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.get("/api/carriers", { page: 1, term: name })
    ).then(function(data) {
      const results = data.carriers;
      if (name[0].toLowerCase() === "u" && component.props.includeUnknown) {
        results.unshift({ name: "Unknown " + Account.carrierTerm(), id: "" });
      }
      return results;
    });
  },
  componentDidMount() {
    if (this.props.autoFocus) {
      const element = ReactDOM.findDOMNode(this);
      window.setTimeout(() => {
        element.focus();
        element.select();
      });
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        "data-component": "CarrierTypeAhead",
        remoteSearch: this.search,
        display: this.carrierDisplay,
        readOnly: this.props.readOnly,
        placeHolder: Account.carrierTerm() + " Name",
        className: "carrier-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.carrier,
        onSelectItem: this.props.onSelectCarrier,
        onClearSelectedItem: this.props.onClearCarrier,
        onSubmit: this.props.onSubmit,
        showTextArea: this.props.showTextArea
      }
    );
  },
  formatAddress: function(address) {
    var html = "<br>";
    if (address.address_line_1) {
      html += address.address_line_1 + " ";
    }
    html += address.city + " ";
    html += address.state + " ";
    html += address.postal_code + " ";
    return html;
  },
  carrierDisplay: function(carrier) {
    var html = carrier.name;
    if (carrier.mc_number) {
      html += " - MC# ";
      html += carrier.mc_number;
    }
    if (carrier.ein) {
      html += " - EIN ";
      html += carrier.ein;
    }
    if (carrier.scac) {
      html += " - SCAC ";
      html += carrier.scac;
    }
    if (carrier.external_vendor_id) {
      var acct = Auth._currentUser.account;
      if (acct.factor_account || acct.settings.show_carrier_external_vendor_id) {
        html += " - ";
        html += carrier.external_vendor_id;
      }
    }
    if (carrier.address_line_1 || carrier.city) {
      html += this.formatAddress(carrier);
    } else if (carrier.payment_address) {
      if (carrier.payment_address.address_line_1 || carrier.payment_address.city) {
        html += this.formatAddress(carrier.payment_address);
      }
    }
    return html;
  }
});
export default CarrierTypeAhead;
